import type { TerminalAdditionalAmountHandlingDto } from "src/app/features/Terminal/types/subTypes/TerminalAdditionalAmountHandlingDto";
import type { TerminalMerchantReferenceNumberDto } from "src/app/features/Terminal/types/subTypes/TerminalMerchantReferenceNumberDto";
import type { TerminalDto } from "src/app/features/Terminal/types/TerminalDto";
import type { TerminalEntity } from "src/app/features/Terminal/types/TerminalEntity";
import { extractNestedObject } from "../../../../../core/utils/utilFunctions";

export const TerminalEntityToDto = ({ dynamicProperties, hostTerminalIds, ...rest }: Readonly<TerminalEntity>): TerminalDto => {
    const propValues = dynamicProperties?.dynamicPropertyValues?.map((propValue) => {
        const value = propValue.type === "TEXT" ? propValue.value || "" : propValue.value;

        return {
            id: propValue.id,
            key: propValue.key,
            type: propValue.type,
            label: propValue.label,
            pattern: propValue.pattern || "",
            readOnly: propValue.readOnly || false,
            value,
        };
    });

    const terminalIds = hostTerminalIds?.map((hostTerminalId) => {
        return {
            id: hostTerminalId.id,
            hostId: hostTerminalId.hostId,
            acquirerId: hostTerminalId.acquirerId,
            terminalId: hostTerminalId.terminalId,
            name: hostTerminalId.name,
            readOnly: hostTerminalId.readOnly,
        };
    });

    // Extract nested objects for the specified prefixes using util function
    const merchantReference1Dto = extractNestedObject<TerminalMerchantReferenceNumberDto>(rest, "merchantReferenceNumber1");
    const merchantReference2Dto = extractNestedObject<TerminalMerchantReferenceNumberDto>(rest, "merchantReferenceNumber2");
    const tipHandlingDto = extractNestedObject<TerminalAdditionalAmountHandlingDto>(rest, "tipHandling");
    const surchargeAmountDto = extractNestedObject<TerminalAdditionalAmountHandlingDto>(rest, "surchargeAmount");
    const taxAmountDto = extractNestedObject<TerminalAdditionalAmountHandlingDto>(rest, "taxAmount");

    const cleanRest = Object.fromEntries(
        Object.entries(rest).filter(
            ([key]) =>
                !key.startsWith("merchantReferenceNumber1") &&
                !key.startsWith("merchantReferenceNumber2") &&
                !key.startsWith("tipHandling") &&
                !key.startsWith("surchargeAmount") &&
                !key.startsWith("taxAmount"),
        ),
    );

    return {
        ...cleanRest,
        hostTerminalIds: terminalIds,
        merchantReferenceNumber1: merchantReference1Dto,
        merchantReferenceNumber2: merchantReference2Dto,
        tipHandling: tipHandlingDto,
        surchargeAmount: surchargeAmountDto,
        taxAmount: taxAmountDto,
        dynamicProperties: {
            ...dynamicProperties,
            dynamicPropertyValues: propValues,
        },
    };
};
